import { render, staticRenderFns } from "./DevelopmentPipelineCard.vue?vue&type=template&id=20226e9a&scoped=true&"
import script from "./DevelopmentPipelineCard.vue?vue&type=script&lang=js&"
export * from "./DevelopmentPipelineCard.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentPipelineCard.vue?vue&type=style&index=0&id=20226e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20226e9a",
  null
  
)

export default component.exports